import { UseEventAccommodationsCheckReturn } from '@shared/hooks/useEventAccommodationsCheck';

type UseAccommodationStepPushCohortArgs = UseEventAccommodationsCheckReturn;

export type AccommodationStepPushCohort = 'hasOwnAccommodations' | 'hasNoAccommodationsAndTravelPages';

export const useAccommodationStepPushCohort = (args: UseAccommodationStepPushCohortArgs): AccommodationStepPushCohort | undefined => {
  const { hasVisibleAccommodationsEventPage, hasAccommodationListings } = args;

  // Easiest cohort to handle:
  //  - only show 1 static card
  //  - directly take them to accommodations.withjoy.com
  if (!hasVisibleAccommodationsEventPage && !hasVisibleAccommodationsEventPage) {
    return 'hasNoAccommodationsAndTravelPages';
  }

  if (hasVisibleAccommodationsEventPage && hasAccommodationListings) {
    return 'hasOwnAccommodations';
  }

  return undefined;
};
